var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconQuote = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.981 9.1a1.74 1.74 0 0 0 1.013-1.487c0-.626-.319-1.413-1.044-1.482M6.7 9.1a1.74 1.74 0 0 0 1.013-1.487c0-.626-.32-1.413-1.044-1.482M8.469.97a6.556 6.556 0 0 0-5.575 10L.969 15.03l4.044-1.925A6.563 6.563 0 1 0 8.469.97m1.406 6.094a.469.469 0 1 0 0-.938.469.469 0 0 0 0 .938m-3.275 0a.469.469 0 1 0 0-.938.469.469 0 0 0 0 .938"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.981 9.1a1.74 1.74 0 0 0 1.013-1.487c0-.626-.319-1.413-1.044-1.482M6.7 9.1a1.74 1.74 0 0 0 1.013-1.487c0-.626-.32-1.413-1.044-1.482M8.469.97a6.556 6.556 0 0 0-5.575 10L.969 15.03l4.044-1.925A6.563 6.563 0 1 0 8.469.97m1.406 6.094a.469.469 0 1 0 0-.938.469.469 0 0 0 0 .938m-3.275 0a.469.469 0 1 0 0-.938.469.469 0 0 0 0 .938"
  }));
});
export default SvgIconQuote;
export const raw = __webpack_public_path__ + "static/media/IconQuote.05e0eeb74c3d38849673b9bd36bcbab8.svg";